import React from "react";

interface WaveDividerProps {
  flip?: boolean;
  className?: string;
  color?: string;
}

export const WaveDivider: React.FC<WaveDividerProps> = ({ flip = false, className = "", color }) => (
  <div
    className={`w-full overflow-hidden leading-[0] pointer-events-none ${flip ? "rotate-180" : ""} ${className}`}
    aria-hidden="true"
  >
    <svg
      viewBox="0 0 1440 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-[30px] sm:h-[40px]"
      preserveAspectRatio="none"
    >
      <path
        d="M0 40C240 10 480 55 720 35C960 15 1200 50 1440 30V60H0V40Z"
        fill={color || "hsl(var(--border) / 0.3)"}
      />
    </svg>
  </div>
);
